<template>
  <section class="container">
    <h1>{{title}}</h1>
    <article>{{content}}</article>
  </section>
</template>
<style lang="scss" scoped>
.container{
  margin: 2em auto;
  padding: 0 1em;
  width: 980px;
}
h1{
  margin: 1em 0;
}
article{
  white-space: break-spaces;
  line-height: 1.5;
  font-size: 16px;
  letter-spacing: 2px;
}
</style>
<script>
import {escapeSpecialChars} from "@/utils/index"
function getData(key){
  const result = JSON.parse(localStorage.getItem(key)) || { title:"",content:"" }
  return {
    ...result,
    content: escapeSpecialChars(result.content)
  }
}
function onPageShow(){
  if(document.visibilityState === "hidden") return
  const punishmentPreview = getData(this.$route.params.storageName)
  this.title = punishmentPreview.title
  this.content = punishmentPreview.content
}
export default {
  data(){
    return {
      ...getData(this.$route.params.storageName),
    }
  },
  mounted(){
    document.addEventListener("visibilitychange", onPageShow.bind(this))
  },
  beforeDestroy(){
    document.removeEventListener("visibilitychange", onPageShow)
  }
}
</script>
